import { ChevronRight } from 'lucide-react';
import { NavLink } from 'react-router';
import type { ModuleDef } from '../config/modules';

/** Breadcrumb, title, subtitle and (optional) sub-page tabs for a module page. */
export function PageHeader({ mod, tab }: { mod: ModuleDef; tab?: string }) {
  return (
    <>
      <div className="page-head">
        <div className="crumbs">
          <span>{mod.group}</span>
          <ChevronRight size={12} />
          <span>{mod.label}</span>
        </div>
        <h1 className="t-title">{mod.label}</h1>
        <p className="t-sub">{mod.subtitle}</p>
      </div>
      {mod.tabs && (
        <nav className="tabs" aria-label={`${mod.label} sections`}>
          {mod.tabs.map((t) => (
            <NavLink
              key={t.id}
              to={`${mod.path}/${t.id}`}
              className={() => `tab${(tab ?? mod.tabs?.[0]?.id) === t.id ? ' active' : ''}`}
            >
              {t.title}
            </NavLink>
          ))}
        </nav>
      )}
    </>
  );
}
